<form name="workTimeDemoDataForm"
      #workTimeDemoDataForm="ngForm"
      (ngSubmit)="submit(workTimeDemoDataForm)"
      *transloco="let t"
      novalidate>

    <h2>{{ t('ADMINISTRATION.MTNC_WTC_DEMO_DATA_INIT') }}</h2>

    <div class="row">
        <div class="col-md-4">
            <dvlib-datepicker-textfield
                inputId="work-time-demo-gueltig-ab"
                name="gueltigAb"
                required
                [(ngModel)]="gueltigAb"
                [placeholder]="t('COMMON.GUELTIG_AB')">
            </dvlib-datepicker-textfield>
        </div>
        <div class="col-md-4">
            <dvlib-datepicker-textfield
                inputId="work-time-demo-gueltig-bis"
                name="gueltigBis"
                required
                [(ngModel)]="gueltigBis"
                [placeholder]="t('COMMON.GUELTIG_BIS')">
            </dvlib-datepicker-textfield>
        </div>
        <div class="col-md-4">
            <input type="number"
                   class="form-control"
                   name="angestellteCount"
                   min="1"
                   required
                   [(ngModel)]="angestellteCount"
                   [placeholder]="t('ADMINISTRATION.MTNC_WTC_DEMO_DATA_ANGESTELLTE_COUNT')"
                   [tooltip]="t('ADMINISTRATION.MTNC_WTC_DEMO_DATA_ANGESTELLTE_COUNT')">
        </div>
    </div>

    <dvlib-loading-button type="submit" [isLoading]="isLoading()">
        <span>{{ t('COMMON.ERSTELLEN') }}</span>
    </dvlib-loading-button>

    @if (result) {
        <div class="normal-abstand-top">
            <p [innerHTML]="t('SCHULUNG.BENUTZERNAME_VALUE', {value: result.name})"></p>
            <p [innerHTML]=" t('SCHULUNG.PASSWORT_VALUE', {value: result.password})"></p>
        </div>
    }
</form>
